module.exports = __webpack_public_path__ + "img/item5.found.a684832d.svg";